var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newslist"},[_c('myHeader',{attrs:{"title":"北斗资讯","sTitle":"Beidou Consulting"}}),_vm._l((_vm.newlistData),function(item){return [_c('NewListItem',_vm._b({key:item.id},'NewListItem',item,false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }